module.exports = __webpack_public_path__ + "static/img/title_ar.32da944e.png";